import { create } from 'zustand';
import { MapState } from './types/MapState';

// Hardcoded capital coordinates
const CAPITAL_COORDINATES: { [key: string]: { latitude: number; longitude: number } } = {
  CHILE: { latitude: -33.4489, longitude: -70.6693 }, // Santiago
  PERU: { latitude: -12.0464, longitude: -77.0428 }, // Lima
};

export const useMapStore = create<MapState>((set, get) => ({
  goToCoordinates: null,
  setGoToCoordinates: (coordinates) => {
    set({ goToCoordinates: coordinates });
  },
  countryCoordinates: null,
  setCountryCoordinates: (coordinates) => {
    set({ countryCoordinates: coordinates });
  },
  initializeCountryCoordinates: (country: string) => {
    const normalizedCountry = country.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    const capital = CAPITAL_COORDINATES[normalizedCountry];
    if (capital) {
      get().setCountryCoordinates({ center: { lat: capital.latitude, lng: capital.longitude } });
    } else {
      get().setCountryCoordinates(null);
    }
  },
}));
